export const EVENT = {
  PLAY_AUDIO: 'mv_mindcommerse_PLAY_AUDIO',
  STOP_AUDIO: 'mv_mindcommerse_STOP_AUDIO',
  SHOW_ACTION: 'mv_mindcommerse_SHOW_ACTION',

  START_BRAIN: 'mv_mindcommerse_PLAY_BRAIN',
  END_BRAIN: 'mv_mindcommerse_END_BRAIN',

  LODING_STATUS: 'mv_mindcommerse_LODING_STATUS',

  SAVE_MIND_INFO: 'mv_mindcommerse_SAVE_MIND_INFO', // 重新开启对话

  CLICK_ANCHOR_EVENT: 'mv_mindcommerse_CLICK_ANCHOR_EVENT',
  SWITCH_ANCHOR_EVENT: 'mv_mindcommerse_SWITCH_ANCHOR_EVENT',

  SHOW_MASK_VIEW: 'mv_mindcommerse_SHOW_MASK_VIEW', // 显示遮罩
  HIDE_MASK_VIEW: 'mv_mindcommerse_HIDE_MASK_VIEW', // 隐藏遮罩层

  UPDATE_MIND_INFO: 'mv_mindcommerse_UPDATE_MIND_INFO', // 通知外部进行 mind 的刷新
  UPDATE_MIND_WITH_OUT_INFO: 'mv_mindcommerse_UPDATE_MIND_WITH_OUT_INFO', // 同上，但不触发客户端「Genius Updated」通知
  UPDATE_PUBLISH_FINISHED: 'mv_mindcommerse_UPDATE_PUBLISH_FINISHED', // 发布完成

  UPDATE_MIND_AND_REOPEN_SESSION: 'mv_mindcommerse_UPDATE_MIND_AND_REOPEN_SESSION', // 重新调用 mindDetail，同时重新开 session

  GET_SESSION_ID: 'mv_mindcommerse_GET_SESSION_ID',

  UPDATE_USER_MEMORY: 'mv_mindcommerse_UPDATE_USER_MEMORY', // 更新用户记忆，弹出提示

  LOG_IN: 'mv_mindcommerse_LOG_IN',
  LOG_OUT: 'mv_mindcommerse_LOG_OUT',

  SHOW_PREVIEW: 'mv_mindcommerse_SHOW_PREVIEW',
  REFRESH_REF_USER_ID: 'mv_mindcommerse_REFRESH_REF_USER_ID',

  GET_MEMORY_SESSION_ID: 'mv_mindcommerse_GET_MEMORY_SESSION_ID',
  UPDATE_USERMEMORY: 'mv_mindcommerse_UPDATE_USERMEMORY',

  UPDATE_SUBSCRIPTION: 'mv_mindcommerse_UPDATE_SUBSCRIPTION', // 更新订阅状态、使用量

  UPDATE_APILIST: 'mv_mindcommerse_UPDATE_APILIST',

  TOKEN_EXPIRED: 'mv_mindcommerse_TOKEN_EXPIRED', // token 过期

  FOLD_MENU: 'mv_mindcommerse_FOLD_MENU', // 折叠菜单
  UNFOLD_MENU: 'mv_mindcommerse_UNFOLD_MENU', // 展开菜单

  SHOW_MENU_PROFILE: 'mv_mindcommerse_SHOW_MENU_PROFILE', // 显示菜单栏的profile
  SHOW_IMPORT_MEMORIES: 'mv_mindcommerse_SHOW_IMPORT_MEMORIES', // 显示菜单栏的import memories

  FOLD_MISSION_LIST: 'mv_mindcommerse_FOLD_MISSION_LIST', // 折叠任务列表

  UNFOLD_SUBSCRIPTION: 'mv_mindcommerse_UNFOLD_SUBSCRIPTION', // 展开订阅列表
  UNFOLD_API_KEY: 'mv_mindcommerse_UNFOLD_API_KEY', // 展开API Key管理

  SELECT_LAYOUT_MENU_ITEM: 'mv_mindcommerse_SELECT_LAYOUT_MENU_ITEM', // 点击左边的菜单栏的 item
  CHANGE_CHAT_STATUS_LAYOUT: 'mv_mindcommerse_CHANGE_CHAT_STATUS_LAYOUT', // 改变聊天区域布局状态
  CHANGE_CHAT_STATUS_LAYOUT_TRULY: 'mv_mindcommerse_CHANGE_CHAT_STATUS_LAYOUT_TRULY', // 改变聊天区域布局状态

  SHOW_MODAL_CHAT: 'mv_mindcommerse_SHOW_MODAL_CHAT', // 显示弹出框形式的聊天框
  HIDE_MODAL_CHAT: 'mv_mindcommerse_HIDE_MODAL_CHAT', // 隐藏弹出框形式的聊天框

  OPEN_OFFICIAL_API_LIBRARY: 'mv_mindcommerse_OPEN_OFFICIAL_API_LIBRARY', // 点开官方技能弹窗
  CONFIRM_ABILITY_AUTH: 'mv_mindcommerse_CONFIRM_ABILITY_AUTH', // 确认ability的auth授权

  UPDATE_TASK_LIST: 'mv_mindcommerse_UPDATE_TASK_LIST', // 更新task列表
  CLOSE_TASK_LIST: 'mv_mindcommerse_CLOSE_TASK_LIST', // 关闭task列表

  UPDATE_MARKET_INFO: 'mv_mindcommerse_UPDATE_MARKET_INFO', // 更新marketplace进入的genius的数据

  SHOW_TEAM: 'mv_mindcommerse_SHOW_TEAM', // 打开左下角的My Team
  HIDE_TEAM: 'mv_mindcommerse_HIDE_TEAM',

  SWITCH_VOICE_MUTE: 'mv_mindcommerse_SWITCH_VOICE_MUTE', // 切换静音

  UPDATE_TASK_NAME: 'mv_mindcommerse_UPDATE_TASK_NAME', // 在每条消息结束的时候调用，更新一下人物名称

  NOTIFICATION: 'mv_notification', // 全局浮窗通知
  CLEAR_SESSION_FINISHED: 'mv_mindcommerse_CLEAR_SESSION_FINISHED', // 清除session

  UPDATE_MENU_BADGE_NOTIFICATION: 'mv_mindcommerse_UPDATE_MENU_BADGE_NOTIFICATION', // 更新菜单栏关于notification的badge
  UPDATE_MENU_BADGE_MISSION: 'mv_mindcommerse_UPDATE_MENU_BADGE_MISSION', // 更新菜单栏关于mission的badge
  UPDATE_MENU_BADGE_SUBSCRIPTION: 'mv_mindcommerse_UPDATE_MENU_BADGE_SUBSCRIPTION', // 更新菜单栏关于subscription的badge
  MENU_TOOLTIP: 'mv_mindcommerse_MENU_TOOLTIP', // 菜单栏的tooltip

  SHOW_MEMORY_POPOVER: 'mv_mindcommerse_SHOW_MEMORY_POPOVER', // 显示菜单栏memory的popover

  SHOW_PINS_POPUP: 'mv_mindcommerse_SHOW_PINS_POPUP', // 显示菜单栏pins的popover
  HIDE_PINS_POPUP: 'mv_mindcommerse_HIDE_PINS_POPUP', // 隐藏菜单栏pins的popover

  SHOW_VIEW_TABS: 'mv_mindcommerse_SHOW_VIEW_TABS', // 显示菜单栏
  HIDE_VIEW_TABS: 'mv_mindcommerse_HIDE_VIEW_TABS', // 隐藏菜单栏
  SWITCH_VIEW_TABS: 'mv_mindcommerse_SWITCH_VIEW_TABS', // 切换菜单栏

  AUTH_CONTACT_FINISHED: 'mv_mindcommerse_AUTH_CONTACT_FINISHED', // 授权通讯录完成

  HAS_SEND_MESSAGE: 'mv_mindcommerse_HAS_SEND_MESSAGE', // 发送消息
  CREATE_NEW_SESSION_WITH_CANVAS_DETAIL: 'mv_mindcommerse_CREATE_NEW_SESSION_WITH_CANVAS_DETAIL', // 创建新的session，同时在开始 session 之后创建会话。
  CHAT_VOICE_RECORDING: 'mv_mindcommerse_CHAT_VOICE_RECORDING', // 语音录音

  WS_NOTICE: 'WS_NOTICE', // ws 业务通知链路

  CLICK_NEW_CHAT_BUTTON: 'mv_mindcommerse_CLICK_NEW_CHAT_BUTTON', // 点击新建chat按钮
  NEW_CHAT_CALLBACK: 'NEW_CHAT_CALLBACK', // 新建chat后更新名字
  CONTINUE_CHAT: 'mv_mindcommerse_CONTINUE_CHAT', // 继续chat
  ADD_VOICE_SESSION_ID: 'mv_mindcommerse_ADD_VOICE_SESSION_ID', // 添加播放声音的sessionIds
  REMOVE_VOICE_SESSION_ID: 'mv_mindcommerse_REMOVE_VOICE_SESSION_ID', // 移除播放声音的sessionIds
  SET_CURRENT_SESSION_ID: 'mv_mindcommerse_SET_CURRENT_SESSION_ID', // 设置当前的session id
  SET_CURRENT_TASK_NAME: 'mv_mindcommerse_SET_CURRENT_TASK_NAME', // 设置当前的session taskName
  DELETE_SESSION_CB: 'mv_mindcommerse_DELETE_SESSION_CB', // 删除chatlist中的session
  UPDATE_CHAT_NOTE: 'mv_mindcommerse_UPDATE_CHAT_NOTE', // 通过消息的-1来更新chat note

  UPDATE_MEMORY_DETAIL_BY_NOTE_ID: 'UPDATE_MEMORY_DETAIL_BY_NOTE_ID', // 通过canvasId更新对应的canvas

  OPEN_ADD_NOTE: 'mv_mindcommerse_OPEN_ADD_NOTE', // 打开添加笔记
  AUTO_ADD_TEXT_NOTE: 'mv_mindcommerse_AUTO_ADD_TEXT_NOTE', // 自动添加Text笔记

  NOTE_ADD_REFRESH: 'mv_mindcommerse_NOTE_ADD_REFRESH', // 添加笔记后刷新

  SEEK_AUDIO_TIMESTAMP: 'mv_mindcommerse_SEEK_AUDIO_TIMESTAMP', // 跳转到音频时间戳
  AUDIO_CURRENT_TIME: 'mv_mindcommerse_AUDIO_CURRENT_TIME', // 音频当前时间

  CLEAR_EDITOR: 'mv_mindcommerse_CLEAR_EDITOR', // 清空编辑器
  FOCUS_EDITOR_END: 'mv_mindcommerse_FOCUS_EDITOR_END', // 聚焦编辑器

  PAGE_VISIBILITY: 'mv_mindcommerse_PAGE_VISIBILITY', // 页面可见性变化

  CLEAR_SEARCH_PARAMS: 'mv_mindcommerse_CLEAR_SEARCH_PARAMS', // 清除搜索参数
  CLOSE_SEARCH_MODAL: 'mv_mindcommerse_CLOSE_SEARCH_MODAL', // 关闭搜索弹窗

  PULL_INTEGRATION_NOTES: 'mv_mindcommerse_PULL_INTEGRATION_NOTES', // 拉取笔记

  CLICK_BIOG: 'mv_mindcommerse_CLICK_BIOG', // 点击biog
  // mobile biog
  SHOW_MOBILE_BIOG: 'mv_mindcommerse_SHOW_MOBILE_BIOG', // 显示mobile biog
  HIDE_MOBILE_BIOG: 'mv_mindcommerse_HIDE_MOBILE_BIOG', // 隐藏mobile biog

  SHOW_MOBILE_MENU_DRAWER: 'mv_mindcommerse_SHOW_MOBILE_MENU_DRAWER', // 显示mobile menu drawer
  HIDE_MOBILE_MENU_DRAWER: 'mv_mindcommerse_HIDE_MOBILE_MENU_DRAWER', // 隐藏mobile menu drawer

  SHOW_MOBILE_VOICE: 'mv_mindcommerse_SHOW_MOBILE_VOICE', // 显示mobile voice
  HIDE_MOBILE_VOICE: 'mv_mindcommerse_HIDE_MOBILE_VOICE', // 隐藏mobile voice

  REFRESH_LIBRARY_HOME: 'mv_mindcommerse_REFRESH_LIBRARY_HOME', //刷新library

  AGENT_SHARE_COLLAPSE: 'mv_mindcommerse_AGENT_SHARE_COLLAPSE',
  AGENT_SHARE_NORMAL: 'mv_mindcommerse_AGENT_SHARE_NORMAL',
  AGENT_SHARE_FULLSCREEN: 'mv_mindcommerse_AGENT_SHARE_FULLSCREEN',

  // Message recall
  MESSAGE_RECALLED: 'mv_mindcommerse_MESSAGE_RECALLED',

  HOMEPAGE_SHOW_TALKS: 'mv_mindcommerse_HOMEPAGE_SHOW_TALKS',
  HOMEPAGE_BREAK_ICE: 'mv_mindcommerse_HOMEPAGE_BREAK_ICE',
  HOMEPAGE_SHOW_LOGIN_MODAL: 'mv_mindcommerse_HOMEPAGE_SHOW_LOGIN_MODAL',
  HOMEPAGE_FRIEND_CONFIRMED: 'mv_mindcommerse_HOMEPAGE_FRIEND_CONFIRMED', // 好友申请确认成功

  OPEN_MISSION_MODAL: 'mv_mindcommerse_OPEN_MISSION_MODAL', // 打开首页任务弹窗

  FINISH_GUIDE: 'mv_mindcommerse_FINISH_GUIDE', //完成引导

  // SLIDE_MODAL_SHOW_MORE: 'mv_mindcommerse_SLIDE_MODAL_SHOW_MORE',
  FLOATING_PANEL_FULLSCREEN: 'mv_mindcommerse_FLOATING_PANEL_FULLSCREEN',
  FLOATING_PANEL_HALF: 'mv_mindcommerse_FLOATING_PANEL_HALF',
  FLOATING_PANEL_ZERO: 'mv_mindcommerse_FLOATING_PANEL_ZERO',

  //Friend
  UPDATE_FRIEND_SESSION: 'mv_mindcommerse_UPDATE_FRIEND_SESSION',

  SHOW_TALK_FINISH_CREATE_SHARE: 'mv_mindcommerse_SHOW_TALK_FINISH_CREATE_SHARE',

  REFRESH_FRIEND_TAB: 'mv_mindcommerse_REFRESH_FRIEND_TAB',

  SHOW_MOBILE_EDIT: 'mv_mindcommerse_SHOW_MOBILE_EDIT', // 显示mobile edit
  HIDE_MOBILE_EDIT: 'mv_mindcommerse_HIDE_MOBILE_EDIT', // 隐藏mobile edit

  INSERT_MENTION: 'mv_mindcommerse_INSERT_MENTION'
};
